















import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref } from "@vue/composition-api";
import MIP from "./index.vue";
import { common_state } from "./data/common.state";
export default Vue.extend({
  components: {
    Modal,
    MIP,
  },

  props: ["modalData"],
  setup() {
    const is_mip_activated = computed(() => {
      if (!common_state.has_setup_status_known.value) {
        return true;
      } else {
        return common_state.state.isMipActivated;
      }
    });

    const config = computed(() => {
      return {
        title: "",
        desc: "",
        blank: true,
        width: is_mip_activated.value ? "130rem" : "80rem",
        height: is_mip_activated.value ? "70rem" : "auto",
        withTopRightCloseBtn: true,
      } as ModalConfig;
    });

    const is_modal_open = ref(false);
    onMounted(() => {
      setTimeout(() => {
        is_modal_open.value = true;
      }, 300);
    });

    return {
      config,
      is_mip_activated,
      is_modal_open,
    };
  },
});
